import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src2515980017/src/src/templates/markdown-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Metadata = makeShortcode("Metadata");
const InfoCollector = makeShortcode("InfoCollector");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Abuse Policy</h1>
    <p>
  We have a zero tolerance policy for abuse. We monitor the use of our systems
  and services to identify and halt any unauthorized use. We also work with all
  appropriate internet security organizations to investigate and respond
  accordingly. Please contact our abuse department to report any issues
  regarding abuse. Your message will be evaluated for merit and acted on where
  appropriate, and therefore, we reserve the right to use your notice to
  substantiate the abuse to our customer. Please be assured that we take abuse
  very seriously and investigate every incident that is reported..
    </p>
    <p>
  Abuse of a registered domain name includes, but is not limited to, the
  following:
    </p>
    <h3>Malware</h3>
    <p>
  Malware, which is short for malicious software, is any software used to
  disrupt normal computer operation, that gathers sensitive information, or
  which may gain access to secure systems. Malware is the general termed used to
  describe all hostile and intrusive forms of software. Types of Malware
  include: computer viruses, ransomware, worms, trojan horses, rootkits,
  keyloggers, dialers, spyware, adware, malicious BHOs (Browser Helper Objects),
  rogue security software, and any other type of malicious program. In all
  countries creation or distribution of Malware (also legally known as a
  computer contaminant) is considered a serious criminal offence.
    </p>
    <h3>Phishing</h3>
    <p>
  The act of attempting to acquire information such as usernames, passwords, and
  credit card details (and sometimes, indirectly, money) by masquerading as a
  trustworthy entity in an electronic communication.
    </p>
    <h3>Spam</h3>
    <p>
  Irrelevant or unsolicited messages sent over the Internet, typically to large
  numbers of users, for the purposes of advertising, phishing, spreading
  malware, etc.
    </p>
    <p>
  We have taken measures to prevent the abuse of our registration engine, web
  hosting, and DNS services at a transactions point of origin in an effort to
  contribute our part to the elimination of spam. If you receive a message
  appearing to be from a domain registered through our company please take a
  moment to report the issue so we can investigate. When reporting spam, we
  would require a copy of the spam message including the message header.
    </p>
    <h3>Pharming</h3>
    <p>
  Pharming refers to redirection of unknowing users to fraudulent sites or
  services, typically through DNS hijacking or poisoning. In other words,
  pharming is intended to redirect a website's traffic to another fraudulent
  sites. It can either be accomplished by changing the hosts file on victim's
  computer or by exploitation of a vulnerability in DNS server software.
    </p>
    <h3>Use of Botnets</h3>
    <p>
  A botnet is a collection of Internet-connected programs communicating with
  other similar programs in order to perform tasks. Botnets can be used to send
  spam email or participate in distributed denial-of-service attacks as well as
  other malicious activities.
    </p>
    <h3>Intellectual Property Rights</h3>
    <p>
  <Metadata name="title" mdxType="Metadata" /> takes Intellectual Property rights seriously. If
  there is a domain with which you have concerns there are a number of options
  available. The first option would be to contact the registrant for the domain
  and attempt to resolve any conflict directly. Contact information for the
  domain owner can be viewed in the{' '}
  <a href="/Whois.aspx" target="_blank">
    Whois tool
  </a>
  .
    </p>
    <p>
  {' '}
  If communications with the registrant is unable to resolve the conflict you can
  file an official dispute on the domain. The process can vary by TLD (Top Level
  Domain, eg. COM), so please contact our customer service team and we can assist
  you with the process.
    </p>
    <h3>How to Report Abuse</h3>
    <p>
  Please contact us at <Metadata name="mailLink" addr="abuse" mdxType="Metadata" /> or at{' '}
  <Metadata name="phone" mdxType="Metadata" />. Please ensure you include as much information as
  you can to assist our investigations.
    </p>
    <p>
  All complaints will be investigated within 24 hours of receipt and we may
  follow up to obtain additional information. Please note that unless we need
  additional information, you will not receive a reply or update from us.
    </p>
    <InfoCollector id="abuse_link" fields={[{
      id: 'name',
      display: 'Full name',
      required: true
    }, {
      id: 'email',
      display: 'Primary Email address',
      type: 'email',
      required: true
    }, {
      id: 'domainService',
      display: 'Domain or Service',
      required: false
    }, {
      id: 'message',
      display: 'Comments',
      required: true,
      type: 'textarea'
    }]} btnProps={{
      color: 'blueDark',
      width: '50%',
      style: {
        margin: '0 auto'
      }
    }} source="abuse-policy-link" successMessage="Abuse reports are reviewed within 24 hours." errorMessage="Something went wrong." title="Have you seen abuse on one of your products? Report it to us and we will help solve it for you!" buttonText="Report Abuse" mdxType="InfoCollector" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      